import { render, staticRenderFns } from "./dialogGetiHint.vue?vue&type=template&id=679324a0&scoped=true&"
import script from "./dialogGetiHint.vue?vue&type=script&lang=js&"
export * from "./dialogGetiHint.vue?vue&type=script&lang=js&"
import style0 from "./dialogGetiHint.vue?vue&type=style&index=0&id=679324a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679324a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679324a0')) {
      api.createRecord('679324a0', component.options)
    } else {
      api.reload('679324a0', component.options)
    }
    module.hot.accept("./dialogGetiHint.vue?vue&type=template&id=679324a0&scoped=true&", function () {
      api.rerender('679324a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/dialog/dialogGetiHint.vue"
export default component.exports